import React, { useCallback, useState } from 'react'
import { Image } from 'semantic-ui-react'

import CareTeamModal from '../CareTeamModal'

import Images from 'images'
import styles from './styles'

const CareTeamCard = ({ provider }) => {
  const { avatar, name, specialization } = provider
  const [isModalOpen, setIsModalOpen] = useState(false)

  const openProviderModal = useCallback(() => {
    setIsModalOpen(true)
  }, [])

  return (
    <div style={styles.container}>
      {avatar && (
        <div style={styles.imageContainer}>
          <Image
            src={Images[avatar]}
            alt={name ? `${name} profile photo` : 'Care team member photo'}
            fluid
            style={styles.image}
          />
        </div>
      )}
      <div style={styles.providerInfoContainer}>
        <div style={styles.infoContainer}>
          <div style={styles.heading}>{name}</div>
          <div style={styles.secondary}>{specialization}</div>
        </div>
        <div style={styles.link} onClick={openProviderModal}>
          View profile ›
        </div>
      </div>
      {isModalOpen && (
        <CareTeamModal
          provider={provider}
          isModalOpen={isModalOpen}
          setIsModalOpen={setIsModalOpen}
        />
      )}
    </div>
  )
}

export default CareTeamCard
